import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Items/Navbar';
import AuthContext from '../shared/AuthContext';
import PageMeta from '../seo/PageMeta';
import UpgradeButton from '../billing/UpgradeButton';

export default function CheckoutCancelPage() {
  const { user } = useContext(AuthContext);

  return (
    <div>
      <PageMeta title="Checkout canceled" description="No changes were made to your plan" />
      <Navbar userProfile={user} loading={false} />
      <main className="checkout-result-shell">
        <div className="checkout-result-card">
          <h1>Checkout canceled</h1>
          <p>No charges were made. You can continue on the Free plan or try again when ready.</p>
          <div className="checkout-result-actions">
            <UpgradeButton plan="pro" interval="monthly" useCheckoutPage>
              Try checkout again
            </UpgradeButton>
            <Link to="/library" className="home-btn home-btn-secondary">Back to home</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
